module.exports = __webpack_public_path__ + "static/media/YF02_3.8d897f33.jpg";